export default "__VITE_ASSET__21d23475__"